import Accordion from "@material-ui/core/esm/Accordion";
import AccordionSummary from "@material-ui/core/esm/AccordionSummary";
import AccordionDetails from "@material-ui/core/esm/AccordionDetails";
import ExpandMore from "@material-ui/icons/esm/ExpandMore";
import React from 'react';
import { Title, BoldSubtitle } from 'components/Text';
import { PRIMARY } from 'constants/colors';
import useStyles from './AccordionStyles';
export default function SimpleAccordion({
  id,
  title,
  children,
  onChange,
  expanded,
  balance
}) {
  const {
    accordionRoot,
    accordionSummary,
    accordionSummaryTitles
  } = useStyles();
  return /*#__PURE__*/React.createElement(Accordion, {
    square: true,
    className: accordionRoot,
    expanded: expanded,
    onChange: onChange
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    className: accordionSummary,
    expandIcon: /*#__PURE__*/React.createElement(ExpandMore, {
      style: {
        fill: PRIMARY
      }
    }),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: accordionSummaryTitles
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true,
    hasNoSpacing: true
  }, title), /*#__PURE__*/React.createElement(BoldSubtitle, {
    align: "right"
  }, balance))), /*#__PURE__*/React.createElement(AccordionDetails, null, children));
}